import React from 'react';

import { getLang } from '@lib/i18n';
import { canUseDOM } from '@lib/canUseDOM';

import type { IClientContext, IClientContextAction } from './ClientContext.typings';
import { clientContextReducer } from './ClientContext.reducer';

// eslint-disable-next-line no-empty-function
const noop = () => {};

export const ClientContext = React.createContext<[IClientContext, React.Dispatch<IClientContextAction>]>([
    {} as IClientContext,
    noop,
]);

export function useClientContext() {
    return React.useContext(ClientContext);
}

const initialClientContext: IClientContext =
    canUseDOM
        ? window.RentApp
        : {
            userInfo: undefined,
            lang: 'en',
            authKey: undefined,
            platform: 'mobile',
            theme: 'light',
        };

export const ClientContextProvider: React.FC<React.PropsWithChildren> = props => {
    initialClientContext.lang = getLang();

    const value = React.useReducer(clientContextReducer, initialClientContext);

    return (
        <ClientContext.Provider value={value}>
            {props.children}
        </ClientContext.Provider>
    );
};
